// src/components/resumo/annotations/commentTooltip.ts
// 🎯 Posicionamento dinâmico do tooltip de comentário

export function initCommentTooltips() {
    let hoverTimeout: NodeJS.Timeout | null = null;

    document.addEventListener('mouseover', (e) => {
        const target = e.target as HTMLElement;

        if (target.classList.contains('highlight-comment-badge')) {
            const badge = target;
            const comment = badge.dataset.comment;

            if (!comment) return;

            // Limpar timeout anterior
            if (hoverTimeout) clearTimeout(hoverTimeout);

            // Aguardar 1.5s antes de mostrar
            hoverTimeout = setTimeout(() => {
                const rect = badge.getBoundingClientRect();
                const scrollY = window.scrollY;
                const scrollX = window.scrollX;

                // ✅ Calcular posição ideal
                let top = rect.top + scrollY - 8;
                let left = rect.left + scrollX + (rect.width / 2);

                // ✅ Aplicar posição via CSS custom properties
                badge.style.setProperty('--tooltip-top', `${top}px`);
                badge.style.setProperty('--tooltip-left', `${left}px`);
                badge.style.setProperty('--arrow-top', `${top}px`);
                badge.style.setProperty('--arrow-left', `${left}px`);
            }, 1500);
        }
    });

    document.addEventListener('mouseout', (e) => {
        const target = e.target as HTMLElement;

        if (target.classList.contains('highlight-comment-badge')) {
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
                hoverTimeout = null;
            }
        }
    });
}